import { ref } from "vue";
import engine from "../core/index";

// ─────────────────────────────────────────────────────────────────────────
// Module « Configuration »
// But actuel : saisir un token / une clé puis cliquer sur Valider (envoi backend).
// Pensé pour évoluer : ajoute ici d'autres champs / actions plus tard.
// ─────────────────────────────────────────────────────────────────────────
export default function () {
    // Valeur saisie dans le champ token / clé
    const token = ref("");
    // État de chargement pendant l'appel backend (désactive le champ + spinner bouton)
    const isLoading = ref(false);
    // Retour visuel utilisateur (snackbar)
    const snackbar = ref({ show: false, text: "", color: "" });

    const showMessage = function (text, color) {
        snackbar.value = { show: true, text: text, color: color };
    };

    // Envoi du token au backend.
    // ⚠️ engine.set_configuration_token est un PLACEHOLDER (voir core/index.js) :
    // remplace le nom de la fonction / de l'endpoint quand tu auras le vrai.
    const validate = function () {
        let value = (token.value || "").trim();
        if (value.length === 0) {
            showMessage("Merci de saisir un token / une clé.", "error");
            return;
        }
        isLoading.value = true;
        engine.set_configuration_token(value, function (data) {
            isLoading.value = false;
            if (data && data.code === 0) {
                showMessage("Token validé avec succès.", "success");
            } else {
                showMessage("Échec de la validation du token.", "error");
            }
        });
    };

    return {
        token,
        isLoading,
        snackbar,
        validate,
    };
}
